import {
  createListingCategoryGetServerSideProps,
  createListingCategoryPage,
} from '@web/library/listing-category-page';
import { Animal, PetAge } from 'shared/@generated/models';

const config = {
  animal: Animal.Dog,
  petAge: PetAge.Newborn,
  translationKey: 'puppies',
};

export default createListingCategoryPage(config);

export const getServerSideProps = createListingCategoryGetServerSideProps(config);
